module.exports = __webpack_public_path__ + "files/f26f9b2f1657b14bdb293ca397ed4e36.png";